module.exports = __webpack_public_path__ + "assets/img/use-scene-1.fd726bb9.png";